<template>
  <Drawer :closable="false" v-model="scanRecordModal" width="700" :title="$t('key1004164')"
    :transfer="false" class-name="scanRecordModalStyle" @on-visible-change="scanRecordChange">
    <template v-if="scanRecordList.length >0">
      <div class="scanRecord_box_item" v-for="(item,index) in scanRecordList">
        <div class="imgBox_item">
          <Tooltip placement="right" theme="light" :transfer="true" transfer-class-name="set_bigimg_style" v-if="item.recordType === 'sku'">
            <img class="img_styles" :src="setImgPath(item.primaryImage)" @error="setErrorImg($event)" alt=""/>
            <template #content>
              <img :ref="'thumbnailImg' + index" @load="handlerOnloadImg('thumbnailImg' + index)"
                :src="setImgPath(item.primaryImage)" @error="setErrorImg($event)" alt=""/>
            </template>
          </Tooltip>
          <div>
            <Button v-if="item.showCancelButton" class="mt10 mb10" type="primary"
              @click="revokeBtn(item)" size="small">{{ $t('key1004165') }}</Button>
            <div v-else class="mt10 mb10" style="font-size: 12px; color: #666; text-align: center">{{ $t('key1004166') }}</div>
          </div>
        </div>
        <Row type="flex" :gutter="gutterItem" class="scanRecord_list">
          <Col :span="twoItemCol" class="basic_item" v-for="(ele, idx) in scanRecordInfo[item.recordType]" :key="idx">
            <span class="basic_title">{{ ele.name }}</span>
            <span class="basic_txt">{{ item[ele.paramsKey] }}</span>
          </Col>
        </Row>
      </div>
    </template>
    <div v-else class="flex justify-content-center flex-direction align-items-center mt20">
      <img :src="noContent" width="200" height="auto" alt="no content">
      <div class="txt mt10">{{ $t('key1000104') }}</div>
    </div>
  </Drawer>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "scanRecordModal",
  mixins: [Mixin],
  props: {
    ymsPickupOrderId: {
      type: String,
      default: null
    },
    originalContainerList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      twoItemCol: 12,
      scanRecordModal: false,
      scanRecordList: [],
      scanRecordInfo: {
        // 订单
        order: [
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001521'), paramsKey: 'trackingNumber'},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004157'), paramsKey: 'labelTypeName'},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004158'), paramsKey: 'supplierPickupOrderNumber'},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002400'), paramsKey: 'code'},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004159'), paramsKey: 'createdTime'}
        ],
        // sku
        sku: [
          {name: 'SKU：', paramsKey: 'ymsSku'},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004157'), paramsKey: 'labelTypeName'},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004158'), paramsKey: 'supplierPickupOrderNumber'},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002400'), paramsKey: 'code'},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003976'), paramsKey: 'supplierSku'},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004159'), paramsKey: 'createdTime'}
        ],
      },
      noContent: require('@/assets/images/noContent.gif'),
    };
  },
  methods: {
    // 初始化数据
    initScanRecordData() {
      let v = this;
      let ymsProductGoodsIds = [];
      if (v.ymsPickupOrderId) {
        v.axios.get(api.get_ymsPickupOrderSortingLog + v.ymsPickupOrderId, {loading: true}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data && data.length > 0) {
              data.map((item) => {
                item.supplierPickupOrderNumber = v.$route.query.supplierPickupOrderNumber;
                item.createdTime = v.$uDate.dealTime(item.createdTime, 'fulltime');
                item.ymsSku = '--';
                item.supplierSku = '--';
                v.originalContainerList.map((ele) => {
                  if (item.containerType === ele.containerType) {
                    item.labelTypeName = ele.labelTypeName;
                  }
                });
                item.ymsProductGoodsId = item.businessId;
                ymsProductGoodsIds.push(item.businessId);
              });
              if (ymsProductGoodsIds.length > 0) {
                (async () => {
                  let newData = await v.getProductInfoByIds(ymsProductGoodsIds, data);
                  newData.map((item) => {
                    if (item._productInfo) {
                      item.ymsSku = item._productInfo.ymsSku ? item._productInfo.ymsSku + ' * ' + item.quantity : '--';
                      item.supplierSku = item._productInfo.supplierSku ? item._productInfo.supplierSku : '--';
                      item.primaryImage = item._productInfo.primaryImage || item._productInfo._spuInfo.primaryImage;
                    }
                    item.recordType = item._productInfo ? 'sku' : 'order';
                    item.trackingNumber = item._productInfo ? '--' : item.businessId;
                  });
                  v.scanRecordList = newData;
                })();
              } else {
                v.scanRecordList = data;
              }
            } else {
              v.scanRecordList = [];
            }
            v.scanRecordModal = true;
          } else {
            v.scanRecordList = [];
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004160'));
        return false;
      }
    },
    // 撤销操作
    revokeBtn(item) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004161'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004162'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004163'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsPickupOrderSortingLog + `${item.ymsPickupOrderSortingLogId}`, null,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.$emit('updateData', item);
              v.initScanRecordData();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 监听弹窗
    scanRecordChange(value) {
      if (!value) {
        this.scanRecordList = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .scanRecordModalStyle {
  .ivu-drawer {
    .ivu-drawer-header-inner {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }

    .ivu-drawer-body {
      padding: 0;

      .scanRecord_box_item {
        display: flex;
        width: 100%;
        padding: 15px 20px;
        border-bottom: 1px solid #e8eaec;

        .imgBox_item {
          display: flex;
          flex-direction: column;
          width: 75px;
          align-items: center;
          flex-wrap: wrap;

          .img_styles {
            width: auto;
            height: 75px;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            max-width: 75px;
          }
        }

        .scanRecord_list {
          flex: 1;
          overflow: hidden;
          padding-left: 30px;
          font-size: 12px;

          .basic_item {
            height: 20px;
            display: flex;
            align-items: center;

            .basic_title {
              display: inline-block;
            }

            .basic_txt {
              max-width: 300px;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }

}
</style>